import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/design-system/utils/cn";
import type { Job } from "~/types/job";
function getIntroductionText(entryLevel?: string, company?: string): string {
  if (entryLevel === "Entry Level") {
    return "We're passionate about creating a more sustainable future. Together, we're leading the transition to net zero. We need everyone's positive energy and innovative thinking to make this happen. Our early careers opportunities offer the chance to work full-time, gain hands-on experience, and grow into your full potential. You'll earn a competitive salary while working towards a recognised qualification. Together, we'll help you build a brighter future, for yourself and for others.";
  }
  if (entryLevel === "Executive Management") {
    return "We're passionate about creating a more sustainable future. Together, we're leading the transition to net zero. Whether you're shaping strategic direction, driving our purpose or accelerating impactful progress, your leadership will inspire best-in-class performance, empower others to contribute and create an environment where people can thrive.";
  }
  if (company === "Npower Business Solutions") {
    return "We're passionate about creating a more sustainable future. Together, we're leading the transition to net zero. We need everyone's positive energy and innovative thinking to make this happen. So whether you're installing solar panels or eco-friendly street lighting, helping customers save energy or making our networks future-proof, you'll be helping to change the world for the better.\n\nnpower Business Solutions (nBS) is the E.ON UK Industrial and Commercial (I&C) pillar and a market leader in the B2B energy retail sector.  I&C is a £6 billion revenue business serving c60,000 customers and around 300,000 meter points with a view to becoming the number one B2B energy supplier in the UK.";
  }
  return "We're passionate about creating a more sustainable future. Together, we're leading the transition to net zero. We need everyone's positive energy and innovative thinking to make this happen. So whether you're installing solar panels or eco-friendly street lighting, helping customers save energy or making our networks future-proof,  you'll be helping to change the world for the better.";
}
export function PrintviewJobadEonUk(t0) {
  const $ = _c(20);
  const {
    job
  } = t0;
  const data = job.data;
  let t1;
  let t2;
  let t3;
  if ($[0] !== data.company || $[1] !== data.entryLevel) {
    const introText = getIntroductionText(data.entryLevel, data.company);
    const paragraphs = introText.split("\n\n");
    t3 = "col-span-6 h-min py-4 pr-8 pl-2";
    t1 = "mb-4 text-sm";
    t2 = paragraphs.map((paragraph, index) => <span key={index}>{paragraph}{index < paragraphs.length - 1 && <><br /><br /></>}</span>);
    $[0] = data.company;
    $[1] = data.entryLevel;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2) {
    t4 = <p className={t1}>{t2}</p>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== job.content.offer) {
    t5 = job.content.offer && <div className="mt-4"><h3 className="mb-2 font-bold text-sm">Here's what you'll be doing</h3><div className={cn("[&_li]:mb-1 [&_p]:mb-2 [&_ul]:mb-2 [&_ul]:ml-4 [&_ul]:list-disc [&_ul]:py-1")} dangerouslySetInnerHTML={{
        __html: job.content.offer
      }} /></div>;
    $[8] = job.content.offer;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== job.content.task) {
    t6 = job.content.task && <div className="mt-4"><h3 className="mb-2 font-bold text-sm">Main responsibilities of the role</h3><div className={cn("[&_li]:mb-1 [&_p]:mb-2 [&_ul]:mb-2 [&_ul]:ml-4 [&_ul]:list-disc [&_ul]:py-1")} dangerouslySetInnerHTML={{
        __html: job.content.task
      }} /></div>;
    $[10] = job.content.task;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== job.content.profile) {
    t7 = job.content.profile && <div className="mt-4"><h3 className="mb-2 font-bold text-sm">What we need from you</h3><div className={cn("[&_li]:mb-1 [&_p]:mb-2 [&_ul]:mb-2 [&_ul]:ml-4 [&_ul]:list-disc [&_ul]:py-1")} dangerouslySetInnerHTML={{
        __html: job.content.profile
      }} /></div>;
    $[12] = job.content.profile;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = <div className={t3}>{t4}{t5}{t6}{t7}</div>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}